export default function BookListHeader({ filterby, setFilterBy }) {
  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button
          className={`lws-filter-btn ${
            filterby === "all" ? "active-filter" : ""
          }`}
          onClick={() => setFilterBy("all")}
        >
          All
        </button>
        <button
          className={`lws-filter-btn ${
            filterby === "featured" ? "active-filter" : ""
          }`}
          onClick={() => setFilterBy("featured")}
        >
          Featured
        </button>
      </div>
    </div>
  );
}
